<template>
    <div class="h-100">
        <div class="d-flex ms-3 mb-3">
            <div class="mt-1">View Editor</div>

            <div class="m-1">
                | View: <strong>{{view.name}}</strong>
            </div>
            <div class="m-1">
                | Layout: {{view.view_type}}
            </div>

            <div class="ms-2">
                <button class="btn btn-sm btn-primary" @click="onSaveClick">save</button>
            </div>

            <div v-if="view && view.id" class="ms-1">
                <router-link :to="{ name: 'view-renderer', params: {id: view.id}}" :key="view.id + 'ViewLink'"
                             class="btn btn-sm btn-primary">
                    open
                </router-link>
            </div>

        </div>

        <div class="row mx-0 h-100" v-if="layout">

            <div class="col-2 bg-light left-sidebar">
                <component-selector :table="table" :view="view"></component-selector>
            </div>

            <div class="col-8 center-container mb-5">
                <layout-renderer :layout="layout" :view="view"></layout-renderer>
            </div>

            <div class="col-2 bg-light right-sidebar px-0">
                <property-editor :layout="layout" :table="table" :view="view"></property-editor>
            </div>
        </div>

        <emoji-modal v-if="showEmojiModal" @noEvent="showEmojiModal = false"
                     :selected-component="layout.selectedComponent"></emoji-modal>

        <image-modal  v-if="showImageModal" @noEvent="showImageModal = false" :view="view" key="bgViewImageModal"
                     :yesEvent="imageSelected"></image-modal>

        <background-editor-modal v-if="showBgEditorModal" @noEvent="showBgEditorModal = false"
                                 :background="layout.selectedRow.background"></background-editor-modal>

        <animation-modal v-if="showAnimationModal" @noEvent="showAnimationModal = false" :component="layout.selectedComponent"></animation-modal>
    </div>
</template>

<script>
    import ViewService from "../../services/ViewService";
    import LayoutFactory from "../../utils/LayoutFactory";
    import LayoutRenderer from "./LayoutRenderer.vue";
    import PropertyEditor from "../properties/PropertyEditor.vue";
    import LayoutUtil from "../../utils/LayoutUtil";
    import ComponentSelector from "./ComponentSelector.vue";
    import ImageModal from "../page/ImageModal.vue";
    import EmojiModal from "../../components/EmojiModal.vue";
    import BackgroundEditorModal from "../page/BackgroundEditorModal.vue";
    import AnimationModal from "../../components/AnimationModal.vue";
    import StateManager from "../state/StateManager";
    import ResourcesService from "../../services/ResourcesService";

    export default {
        name: 'ViewEditor',
        components: {
            AnimationModal,
            BackgroundEditorModal, EmojiModal, ImageModal, ComponentSelector, PropertyEditor, LayoutRenderer},
        data() {
            return {
                model: webase.model,
                service: new ViewService(),
                view: {
                    id: null,
                    name: '',
                    view_type: '',
                },
                table: null,
                layout: null,
                selectedRow: null,
                selectedColumn: null,
                showImageModal: false,
                imageSelected: function (image) {
                },
                timerId: null,
                showEmojiModal: false,
                showBgEditorModal: false,
                showAnimationModal: false
            }
        },
        mounted() {
            window.scrollTo(0, 0)
            webase.managers.state = new StateManager()

            let viewId = this.$route.params.id
            console.log('********************* view id: ' + viewId)

            this.service.get(viewId).then((view) => {

                let description = ''

                if(view.layout.description === undefined) {
                    view.layout.description = description
                }
                else {
                    description = view.layout.description
                }

                view.layout.theme_id = view.app.theme_id

                if(view.app.theme_id) {
                    webase.utils.ui.injectCss(`themes/${view.app.theme_id}`)
                }

                if(view.layout.rows) {
                    let layoutUtil = new LayoutUtil()
                    layoutUtil.initConditions(view.layout)
                }

                this.view = view
                let app = view.app
                console.log('View Editor init app')
                webase.utils.app.initAppProperties(app)
                this.model.app = app
                this.table = webase.utils.array.get(this.model.app.tables, this.view.model_id)

                if(this.view.layout.rows) {
                    this.layout = this.view.layout
                    this.clearSelections()  // deselect everything
                }
                else {
                    let factory = new LayoutFactory(this.table)
                    this.layout = factory.createLayout(this.view)
                }

                this.layout.description = description // ensure description is preserved

            }).catch((message) => {
                console.log('error loading view')
                console.log(message)
            })

            let resourcesService = new ResourcesService()
            resourcesService.getIcons()
            webase.eventDispatcher.on('updateBackgroundClick', this.onSetBackgroundClick)
            webase.eventDispatcher.on('editBackgroundPatternClick', this.onEditBackgroundPatternClick)
            webase.eventDispatcher.on('editAnimationClick', this.onEditAnimationClick)
            webase.eventDispatcher.on('addEmojiClick', this.onAddEmojiClick)
            this.timerId = setInterval(this.onSaveClick, 5000);
        },
        beforeUnmount() {
            webase.eventDispatcher.off('updateBackgroundClick', this.onSetBackgroundClick)
            webase.eventDispatcher.off('editBackgroundPatternClick', this.onEditBackgroundPatternClick)
            webase.eventDispatcher.off('editAnimationClick', this.onEditAnimationClick)
            webase.eventDispatcher.off('addEmojiClick', this.onAddEmojiClick)

            if(this.timerId) {
                clearInterval(this.timerId)
            }

            this.timerId = null
            this.onSaveClick()
            this.clearSelections()
        },
        methods: {
            clearSelections() {
                console.log('ViewEditor, clear selections')
                webase.utils.layout.deselectAll(this.layout)
                this.layout.selectedComponent = null
                this.layout.selectedColumn = null
                this.layout.selectedRow = null
            },
            onSaveClick() {
                if(this.view.id === null) {
                    return
                }

                let request = {
                    view: {
                        layout: this.layout
                    }
                }

                this.service.update(this.view.id, request).catch((message) => {
                    console.log('error updating view')
                    console.log(message)
                })
            },
            onResetClick() {
                this.layout = {}
                this.onSaveClick()
                let factory = new LayoutFactory(this.table)
                this.layout = factory.createLayout(this.view)
            },
            onSetBackgroundClick() {
                this.showImageModal = true

                this.imageSelected = (image) => {

                    if(this.layout.selectedRow) {
                        this.layout.selectedRow.background.image = image
                    }
                }
            },
            onAddEmojiClick() {
                this.showEmojiModal = true
            },
            onEditBackgroundPatternClick() {
                this.showBgEditorModal = true
            },
            onEditAnimationClick() {
                this.showAnimationModal = true
            },
        }
    }
</script>
